// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"ef77b061","148":"7fffc1b0","215":"5be430bf","695":"654f94e1"}[chunkId] + ".chunk.css";
};